import React from "react"

import ReactTable from "react-table"

import { APIPost, APIGet } from "services/APIRequest"
import ConfigHost from "services/ConfigHost"

import { arrayObject } from "ConvertKey"
import UrlServer from "configs/UrlServer"
import Auth from "auth"
import Lg from "language"
import { ErrorsCallback, SuccessCallback, WarningCallback } from "alertService"

import { ISOToDateFormat, ISOToDateYMDAndFullTime, MMDDYYYYForDatetime } from "helpers/ConvertDate"
import { thaiBath } from "helpers/ConvertFormat"
import Datetime from "react-datetime";
import { replaceNumberQuestion } from "helpers/ConvertString"
import * as Alert from "alertService"

import wordingQuestion from "configs/wordingQuestion.jsx"

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles"

import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";

// @material-ui/icons
import ViewListIcon from '@material-ui/icons/ViewList';
import CloudDownloadIcon from "@material-ui/icons/CloudDownload"
import SearchIcon from "@material-ui/icons/Search";
import CachedIcon from '@material-ui/icons/Cached';


// core components
import GridContainer from "components/Grid/GridContainer.jsx"
import GridItem from "components/Grid/GridItem.jsx"
import Button from "components/CustomButtons/Button.jsx"
import Card from "components/Card/Card.jsx"
import CardBody from "components/Card/CardBody.jsx"
import CardIcon from "components/Card/CardIcon.jsx"
import CardHeader from "components/Card/CardHeader.jsx"
import Autocomplete from "components/Autocomplete/Select.jsx";

import { cardTitle } from "assets/jss/material-dashboard-pro-react.jsx"
import regularFormsStyle from "assets/jss/material-dashboard-pro-react/views/regularFormsStyle"
const styles = {
  ...regularFormsStyle,
  cardIconTitle: {
    ...cardTitle,
    marginTop: "15px",
    marginBottom: "0px"
  },
  marginHR: {
    marginTop: "35px",
    marginBottom: "-5px"
  },
  mt4: {
    marginTop: "15px"
  }
}

class LogClearDataPage extends React.Component {
  constructor(props) {
    super(props)
    this.state = { 
      dataTableListRaw: [],
    }
  }
  componentDidMount() {
    this.onDownloadData()
  }
  onDownloadData(callback) {
    Alert.Loading(true)
    const dataToSend = {
    }
    APIPost(UrlServer.URL_POST_LOG_CLEAR_DATA_EXPIRED_AUTO_GET, dataToSend, (datas) => {
      this.setState({
        dataTableListRaw: datas.datas,
      }, () => {
        Alert.LoadingClose()
        if (callback) callback()
      })
    })
  }
  renderListData = data => {
    return data.map((CData, key) => {
      return {
        id: (key + 1), 
        delete_total: CData.delete_total, 
        expired_date_iso: ISOToDateYMDAndFullTime(CData.expired_date_iso),
        created_date_iso: ISOToDateYMDAndFullTime(CData.created_date_iso),
        actions: (
          <div>
          </div>
        ),
      }
    })
  }
  render() {
    const { classes } = this.props
    var columnsTable = [
      {
        Header: "#",
        accessor: "id",
        width: 50
      },
      {
        Header: Lg.ts("delete_total"),
        accessor: "delete_total",
        width: 120 
      },
      {
        Header: Lg.ts("expired_date_iso"),
        accessor: "expired_date_iso",
        width: 170,
        filterMethod: (filter, row) => {
          return row.expired_date_iso.toLowerCase().indexOf(filter.value.toLowerCase()) >= 0;
        }
      }, 
      {
        Header: Lg.ts("created_date_iso"),
        accessor: "created_date_iso",
        width: 170,
        filterMethod: (filter, row) => {
          return row.created_date_iso.toLowerCase().indexOf(filter.value.toLowerCase()) >= 0;
        }
      }, 
      {
        Header: Lg.ts("-"),
        accessor: "actions",
        width: 10,
        filterMethod: (filter, row) => {
          return row.actions.toLowerCase().indexOf(filter.value.toLowerCase()) >= 0;
        }
      }, 
    ]
    return (
      <div className={"card-space"} >
        <GridContainer >
          <GridItem xs={12}>
            <Card>
              <CardHeader color="info" icon>
                <CardIcon color="info">
                  <ViewListIcon />
                </CardIcon>
                <h4 className={classes.cardIconTitle}>{Lg.ts("บันทึกรายการลบข้อมูลอัตโนมัติ")}</h4>
              </CardHeader>
              <CardBody>
                <form>
                  <GridContainer >
                    <GridItem xs={12} sm={12} md={12}>
                      <GridContainer className={classes.mt4}>
                        <GridItem xs={12} sm={12} md={12}>
                          <span>{Lg.ts("จำนวน")} {thaiBath(this.state.dataTableListRaw.length, false)} {Lg.ts("รายการ")}</span>
                          <ReactTable
                            className="table-scroll"
                            data={this.renderListData(this.state.dataTableListRaw)}
                            filterable
                            columns={columnsTable}
                            defaultPageSize={10}
                            showPaginationTop
                          />
                        </GridItem>
                      </GridContainer>
                    </GridItem>
                  </GridContainer>
                </form>
              </CardBody>
            </Card>
          </GridItem>
        </GridContainer>
      </div>
    )
  }
}

export default withStyles(styles)(LogClearDataPage)
